export default __webpack_public_path__ + "assets/images/871509066afb12bfd112ba85f8342b82.jpg";